import { FC, useEffect, useState } from "react";
import { useBle } from "../context/BleContext";
import ConnectButton from "../components/layout/ConnectButton";
//import FormWiFi from "../components/form/FormWiFi";
//import FormWallet from "../components/form/FormWallet";
//import FormInverter from "../components/form/FormInverter";
//import Accordion from "../components/Accordion";
import ConnectedInfoBox from "../components/connectedinfobox/ConnectedInfoBox";
import PageContainer from "../components/layout/PageContainer";
import NotificationsComponent from "../components/Notifications";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

import * as ble from "../services/ble/";

// react-icons
// import { CiPlug1, CiTimer, CiCircleCheck } from "react-icons/ci";

enum ActiveState {
  Unconnected,
  Normal,
  Notificaion
}

const ConnectGW: FC = () => {
  // useEGW connections
  const bleApi = useBle();
  const [activeState, setActiveState] = useState<ActiveState>(ActiveState.Unconnected);

  // listen for connection changes
  useEffect(() => {
    function observerCallback(m: ble.IManager) {
      console.log("Connection status changed: ", m.isConnected());
      if (m.isConnected()) {
        if (activeState === ActiveState.Unconnected) {
          setActiveState(ActiveState.Normal);
        }
      } else {
        setActiveState(ActiveState.Unconnected);
      }
    }

    bleApi.manager.subscribeToConnectionStatus(observerCallback);

    return () => {
      bleApi.manager.unsubscribeFromConnectionStatus(observerCallback);
    };
  }, [bleApi, activeState]);

  return (
    <>
      <PageContainer>
        <div className="mb-6 sm:mb-8 mt-1 sm:mt-1">
          <div className="flex items-center gap-4 mb-2 sm:mb-4">
            <div className="flex items-center gap-2">
              <InformationCircleIcon className="w-5 h-5 text-[#00FF84]" />
              <h1 className="text-xl font-bold text-white">
                Gateway Information
              </h1>
            </div>
          </div>
        </div>
        
        {activeState !== ActiveState.Unconnected ? (
          <>
            {activeState === ActiveState.Normal ? (
              <div className="space-y-6">
                <h2 className="text-xl font-medium text-white">Connected to Gateway</h2>
                <button className="w-full py-3 rounded-[8px] bg-[#FF3B5C] text-white font-medium hover:bg-[#FF3B5C]/90" onClick={async () => await bleApi.manager.disconnect()}>
                  Disconnect
                </button>
                <div className="bg-[#1D1D1D] p-4 rounded-[8px] border border-[#292929]">
                  <ConnectedInfoBox bleApi={bleApi} />
                </div>
                <button className="w-full py-3 rounded-[8px] bg-[#00FF84] text-black font-medium hover:bg-[#00FF84]/90" onClick={()=>setActiveState(ActiveState.Notificaion)}>
                  Notifications
                </button>
              </div>
            ) : (
              <div className="space-y-6">
                <h2 className="text-xl font-medium text-white">Gateway Notifications</h2>
                <button className="w-full py-3 rounded-[8px] bg-[#292929] text-white font-medium hover:bg-[#333333]" onClick={()=>setActiveState(ActiveState.Normal)}>
                  Back
                </button>
                <div className="bg-[#1D1D1D] p-4 rounded-[8px] border border-[#292929]">
                  <NotificationsComponent bleApi={bleApi} />
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="space-y-6">
            <p className="text-gray-400">
              Connect directly to your gateway via Bluetooth and show information about the gateway.
            </p>
            <div className="p-4 bg-[#00FF84]/10 border border-[#00FF84]/50 rounded-lg text-[#00FF84]">
              <p>
                Not all platforms have bluetooth enabled by default. Please make
                sure that your bluetooth is enabled before connecting.
              </p>
            </div>
            <div className="flex justify-center mt-[30px]">
              <ConnectButton
                onClick={async () => bleApi.manager.connect()}
              />
            </div>
          </div>
        )} 
      </PageContainer>
    </>
  );
};

export default ConnectGW;
